/**
    @function unique
    @desc ES5 implementation to reduce an Array of values to unique instances.
    @param {Array} objects The Array of objects to be filtered.
    @example <caption>this</caption>
unique(["apple", "banana", "apple"]);
    @example <caption>returns this</caption>
["apple", "banana"]
*/
export default function (arr) {
  return arr.filter(function (k, i, a) {
    return a.indexOf(k) === i;
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/d3plus-common/es/src/unique.js
// module id = MVPt
// module chunks = 0